module.exports = __webpack_public_path__ + "static/img/pic_rjyf_xmal01.d180ec6a.png";